(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStack(root) {
    var stack = root.querySelector('[data-kojido-stack]');
    if (!stack || stack.getAttribute('data-kojido-init')) return;
    var items = [].slice.call(stack.querySelectorAll('[data-kojido-item]'));
    var n = items.length;
    if (n < 2) return;
    stack.setAttribute('data-kojido-init', '1');

    var dots = [].slice.call(root.querySelectorAll('[data-kojido-dot]'));
    var nameEl = root.querySelector('[data-caption-name]');
    var linkEl = root.querySelector('[data-caption-link]');
    var textEl = root.querySelector('[data-caption-text]');
    var active = 0;
    var timer = null;
    var stopped = false;
    var speed = (parseInt(stack.getAttribute('data-autoplay'), 10) || 0) * 1000;

    function render() {
      items.forEach(function (it, i) {
        var rel = (i - active + n) % n;
        var state = 'hidden';
        if (rel === 0) state = 'front';
        else if (rel === 1) state = 'next';
        else if (rel === n - 1) state = 'prev';
        it.setAttribute('data-state', state);
        it.setAttribute('aria-hidden', rel === 0 ? 'false' : 'true');
      });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === active ? 'true' : 'false'); });
      var cur = items[active];
      if (nameEl) nameEl.textContent = cur.getAttribute('data-name') || '';
      if (linkEl) {
        var href = cur.getAttribute('data-link');
        if (href) {
          linkEl.setAttribute('href', href);
          linkEl.hidden = false;
          if (textEl) textEl.textContent = cur.getAttribute('data-label') || '';
        } else {
          linkEl.hidden = true;
        }
      }
    }

    function go(i) { active = (i + n) % n; render(); }
    function userGo(i) { stopped = true; clearTimer(); go(i); }

    function clearTimer() { if (timer) { clearInterval(timer); timer = null; } }
    function startTimer() {
      if (stopped || reduce || !speed || timer) return;
      timer = setInterval(function () { go(active + 1); }, speed);
    }

    items.forEach(function (it, i) {
      it.addEventListener('click', function () {
        var rel = (i - active + n) % n;
        userGo(rel === 0 ? active + 1 : i);
      });
    });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { userGo(i); }); });

    // swipe
    var sx = null;
    stack.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stack.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      sx = null;
      if (Math.abs(dx) > 40) userGo(active + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // autoplay solo quando visibile e senza hover/focus
    root.addEventListener('mouseenter', clearTimer);
    root.addEventListener('mouseleave', startTimer);
    root.addEventListener('focusin', clearTimer);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) startTimer(); else clearTimer(); });
      }, { threshold: 0.35 }).observe(stack);
    } else {
      startTimer();
    }
    render();
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('.koji-kojido-wrapper'), initStack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();